import React from 'react';
import { useDispatch } from 'react-redux';
import { useFirebase } from 'react-redux-firebase';

import { BLUEBIRD_SETTINGS_FIRESTORE_COLLECTION, SHIPPING_RULES_FIRESTORE_DOC_ID } from '../../constants/shell';

import { updateShippingRules } from '../../store/actions/shell';
import { IShippingRules } from '../../types/shell';

const ShippingRules = () => {
  const firebase = useFirebase();
  const dispatch = useDispatch();

  React.useEffect(() => {
    return firebase
      .firestore()
      .collection(BLUEBIRD_SETTINGS_FIRESTORE_COLLECTION)
      .doc(SHIPPING_RULES_FIRESTORE_DOC_ID)
      .onSnapshot((snapshot) => {
        const shippingRules = snapshot?.data() as IShippingRules;
        dispatch(updateShippingRules(shippingRules));
      });
  }, []);

  return null;
};

export default ShippingRules;
